import React from 'react';

/**
 * Modern Button Component with new design system
 * Variants: primary, secondary, ghost, danger, success
 */
const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  className = '', 
  disabled = false,
  loading = false,
  ...props 
}) => {
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800 shadow-sm hover:shadow-md disabled:bg-slate-400',
    secondary: 'bg-white text-slate-900 border-2 border-slate-300 hover:border-slate-400 hover:bg-slate-50 shadow-sm hover:shadow-md disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200',
    ghost: 'text-slate-600 hover:bg-slate-100 disabled:text-gray-400',
    danger: 'bg-rose-600 text-white hover:bg-rose-700 shadow-sm disabled:bg-rose-400',
    success: 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm disabled:bg-emerald-400',
    outline: 'bg-transparent text-slate-900 border-2 border-slate-900 hover:bg-slate-900 hover:text-white shadow-sm hover:shadow-md disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-300'
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };

  return (
    <button 
      disabled={disabled || loading}
      aria-busy={loading ? 'true' : undefined}
      className={`
        inline-flex items-center justify-center gap-2 rounded-lg font-medium 
        transition-all duration-200 active:scale-95 disabled:cursor-not-allowed 
        disabled:opacity-60 disabled:active:scale-100
        ${variants[variant]} 
        ${sizes[size]} 
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

